import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	fields: {
		display: "flex",
		gap: theme.spacing(2),
		marginTop: theme.spacing(1),
	},
	amountField: {
		flex: 1,
	},
	unitField: {
		flex: 1,
	},
}));

const UNIT_SECONDS = {
	minutes: 60,
	hours: 3600,
	days: 86400,
};

const PostponeCustomDialog = ({ open, onClose, onConfirm }) => {
	const classes = useStyles();
	const [amount, setAmount] = useState("");
	const [unit, setUnit] = useState("hours");
	const [error, setError] = useState(false);

	const handleClose = () => {
		setAmount("");
		setUnit("hours");
		setError(false);
		onClose();
	};

	const handleConfirm = () => {
		const numericAmount = parseFloat(amount);
		if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
			setError(true);
			return;
		}

		const durationSeconds = Math.round(numericAmount * UNIT_SECONDS[unit]);
		onConfirm(durationSeconds);
		handleClose();
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
			<DialogTitle>{i18n.t("ticketsList.postpone.customTitle")}</DialogTitle>
			<DialogContent>
				<div className={classes.fields}>
					<TextField
						className={classes.amountField}
						label={i18n.t("ticketsList.postpone.amountLabel")}
						type="number"
						inputProps={{ min: 0, step: 0.5 }}
						value={amount}
						error={error}
						helperText={error ? i18n.t("ticketsList.postpone.invalidAmount") : ""}
						onChange={e => {
							setAmount(e.target.value);
							setError(false);
						}}
						variant="outlined"
						margin="dense"
						autoFocus
					/>
					<Select
						className={classes.unitField}
						value={unit}
						onChange={e => setUnit(e.target.value)}
						variant="outlined"
						margin="dense"
					>
						<MenuItem value="minutes">
							{i18n.t("ticketsList.postpone.units.minutes")}
						</MenuItem>
						<MenuItem value="hours">
							{i18n.t("ticketsList.postpone.units.hours")}
						</MenuItem>
						<MenuItem value="days">
							{i18n.t("ticketsList.postpone.units.days")}
						</MenuItem>
					</Select>
				</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>
					{i18n.t("ticketsList.postpone.cancel")}
				</Button>
				<Button onClick={handleConfirm} color="primary" variant="contained">
					{i18n.t("ticketsList.postpone.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PostponeCustomDialog;
